import { styled } from 'react-alicerce-components';

export const Modifier = styled.div`
  padding: 1rem;

label {
  background-color: #8F9BB3 !important;
}
`;